/* eslint-disable */
export default {
  forward: 'Forward',
  reply: 'Reply',
  ignore: 'Ignore',
  toVoicemail: 'To voicemail',
  answer: 'Answer',
  answerAndEnd: 'Answer & End',
  answerAndHold: 'Answer & Hold',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"answerAndEnd"@#@ @source: @#@"Answer & End"@#@
// @key: @#@"answerAndHold"@#@ @source: @#@"Answer & Hold"@#@
